(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-einstant/assets/javascripts/lobby/category/page.js') >= 0) return;  svs.modules.push('/modules/tickets-einstant/assets/javascripts/lobby/category/page.js');
"use strict";


const {
  useEffect,
  useContext,
  useMemo
} = React;
const Icon = svs.ui.ReactIcon;
const {
  useHistory,
  useParams
} = ReactRouterDOM;
const {
  GridCol,
  GridRow
} = svs.ui.ReactGrid;
const {
  ROUTES: {
    LOBBY,
    CATEGORY
  },
  getSortOptionById
} = svs.eInstant.constants;
const GameGrid = svs.eInstant.shared.GameGrid;
const ScrollToTop = svs.eInstant.components.ScrollToTop;
const Category = () => {
  var _getSortOptionById;
  const {
    InfoOverlay,
    Background,
    SortGames
  } = svs.eInstant.shared.components;
  const history = useHistory();
  const {
    categoryId
  } = useParams();
  const {
    state: {
      gameUrl,
      categories
    }
  } = useContext(svs.eInstant.store.RouterContext);
  const category = categories.find(cat => cat.urlPath === categoryId) || {
    games: []
  };
  const featuredGame = category === null || category === void 0 ? void 0 : category.featuredGame;
  const {
    update
  } = svs.eInstant.shared.hooks.useMetaTags({
    category
  });
  const [selected, setSelected] = svs.eInstant.shared.hooks.useLocalStorage(category === null || category === void 0 ? void 0 : category.urlPath, 'tickets-einstant-sort-games', null, 60);
  const sortFn = (_getSortOptionById = getSortOptionById(selected)) === null || _getSortOptionById === void 0 ? void 0 : _getSortOptionById.sortFn;
  const sortedGames = useMemo(() => sortFn(category.games || []), [sortFn, category.games]);
  const FeaturedGame = svs.eInstant.lobby.category.components.FeaturedGame;
  useEffect(() => {
    !gameUrl && update(CATEGORY);
  }, [category, gameUrl]);
  useEffect(() => {
    if (!category || !(category.games || []).length) {
      const dialog = new svs.ui.dialog.Confirm({
        branding: svs.ui.dialog.branding.TUR,
        type: svs.ui.dialog.type.ERROR,
        title: 'Kunde inte hämta kategori',
        message: [{
          type: svs.ui.dialog.message.TEXT,
          text: 'Försök igen senare eller kontakta kundservice.'
        }],
        actions: [{
          title: 'Okej',
          callback: () => {
            dialog.close();
            history.push(LOBBY);
          }
        }]
      });
      svs.ui.dialog.api.add(dialog);
    }
  }, [category, history, LOBBY]);
  if (!category || !sortedGames.length) {
    return React.createElement(Background, {
      classNames: "tickets-einstant-background-category"
    });
  }
  return React.createElement(Background, {
    classNames: "tickets-einstant-background-category"
  }, React.createElement(InfoOverlay, {
    onCloseUrl: "".concat(svs.core.data.baseUrl).concat(CATEGORY.replace(':categoryId', category.urlPath))
  }), React.createElement(ScrollToTop, null), featuredGame && React.createElement("div", {
    className: "tickets-einstant-special-width-header"
  }, React.createElement("div", {
    className: "u-flex u-flex-column margin-top-3 margin-h-1"
  }, React.createElement("div", {
    className: "f-body u-flex u-flex-row u-flex-align-items-center margin-bottom-2"
  }, React.createElement(Icon, {
    color: "fc-fler-lotter-new-700 margin-right-half",
    icon: category.icon,
    size: 500
  }), React.createElement("h1", {
    className: "h1 fc-fler-lotter-new-700 margin-0"
  }, category.title)))), React.createElement(FeaturedGame, {
    featuredGame: featuredGame
  }), React.createElement("div", {
    className: "tickets-einstant-max-width w100"
  }, React.createElement("div", {
    className: "u-flex u-flex-column margin-v-2 margin-h-1"
  }, React.createElement(GridRow, {
    className: "u-flex u-flex-align-items-center",
    gutter: "0"
  }, !featuredGame && React.createElement(GridCol, {
    am: 8,
    lg: 10,
    md: 8,
    xs: 12
  }, React.createElement("div", {
    className: "tickets-einstant-special-width-header"
  }, React.createElement("div", {
    className: "u-flex u-flex-column margin-top-1"
  }, React.createElement("div", {
    className: "f-body u-flex u-flex-row u-flex-align-items-center margin-bottom-2"
  }, React.createElement(Icon, {
    color: "fc-fler-lotter-new-700 margin-right-half",
    icon: category.icon,
    size: 500
  }), React.createElement("h1", {
    className: "h1 fc-fler-lotter-new-700 margin-0"
  }, category.title))))), React.createElement(GridCol, {
    am: 4,
    className: "tickets-einstant-margin-left-auto",
    lg: 2,
    md: 4,
    xs: 12
  }, React.createElement(SortGames, {
    key: category.urlPath,
    selected: selected,
    setSelected: setSelected
  }))), React.createElement("div", {
    className: "margin-top-1-half"
  }, React.createElement(GameGrid, {
    games: sortedGames
  })))));
};
setGlobal('svs.eInstant.lobby.Category', Category);

 })(window);